import React from 'react';

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const BaseIcon: React.FC<IconProps & { children: React.ReactNode }> = ({
  size = 16,
  color = 'currentColor',
  children,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    {children}
  </svg>
);

export const EjectIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <path d="M12 5L5.5 13.5H18.5L12 5Z" />
    <line x1="5.5" y1="18" x2="18.5" y2="18" />
  </BaseIcon>
);

export const RewindIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <polygon points="11 18 3.5 12 11 6 11 18" />
    <polygon points="20.5 18 13 12 20.5 6 20.5 18" />
  </BaseIcon>
);

export const PlayWedgeIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <polygon points="6.5 4.5 19.5 12 6.5 19.5 6.5 4.5" fill="currentColor" />
  </BaseIcon>
);

export const PauseBarsIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <rect x="6.5" y="4.5" width="4" height="15" rx="1" fill="currentColor" />
    <rect x="13.5" y="4.5" width="4" height="15" rx="1" fill="currentColor" />
  </BaseIcon>
);

export const FastForwardIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <polygon points="3.5 18 11 12 3.5 6 3.5 18" />
    <polygon points="13 18 20.5 12 13 6 13 18" />
  </BaseIcon>
);

export const PrevTapeIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <polygon points="19 18 9.5 12 19 6 19 18" />
    <line x1="5.5" y1="6" x2="5.5" y2="18" />
  </BaseIcon>
);

export const NextTapeIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <polygon points="5 18 14.5 12 5 6 5 18" />
    <line x1="18.5" y1="6" x2="18.5" y2="18" />
  </BaseIcon>
);

export const CassetteReelIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="3" />
    <line x1="12" y1="3" x2="12" y2="9" />
    <line x1="4.2" y1="16.5" x2="9.4" y2="13.5" />
    <line x1="19.8" y1="16.5" x2="14.6" y2="13.5" />
  </BaseIcon>
);

export const AzimuthLockIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <circle cx="12" cy="12" r="8.5" />
    <circle cx="12" cy="12" r="2.5" />
    <line x1="12" y1="2.5" x2="12" y2="6" />
    <line x1="12" y1="18" x2="12" y2="21.5" />
    <line x1="2.5" y1="12" x2="6" y2="12" />
    <line x1="18" y1="12" x2="21.5" y2="12" />
  </BaseIcon>
);

export const VuMeterIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <line x1="7" y1="15" x2="7" y2="10" />
    <line x1="10.5" y1="15" x2="10.5" y2="8" />
    <line x1="14" y1="15" x2="14" y2="11" />
    <line x1="17.5" y1="15" x2="17.5" y2="7" />
  </BaseIcon>
);

export const DacChipIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <rect x="6.5" y="6.5" width="11" height="11" rx="1.5" />
    <rect x="9.5" y="9.5" width="5" height="5" rx="0.5" />
    <line x1="9" y1="3" x2="9" y2="6.5" />
    <line x1="15" y1="3" x2="15" y2="6.5" />
    <line x1="9" y1="17.5" x2="9" y2="21" />
    <line x1="15" y1="17.5" x2="15" y2="21" />
    <line x1="3" y1="9" x2="6.5" y2="9" />
    <line x1="3" y1="15" x2="6.5" y2="15" />
    <line x1="17.5" y1="9" x2="21" y2="9" />
    <line x1="17.5" y1="15" x2="21" y2="15" />
  </BaseIcon>
);

export const LyricsIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <path d="M5 6H19" />
    <path d="M5 10.5H15" />
    <path d="M5 15H13" />
    <circle cx="17.5" cy="16.5" r="2" />
    <path d="M19.5 16.5V11L21 12" />
  </BaseIcon>
);

export const QueueRackIcon: React.FC<IconProps> = (props) => (
  <BaseIcon {...props}>
    <rect x="3.5" y="4.5" width="17" height="4.5" rx="1" />
    <rect x="3.5" y="10.5" width="17" height="4.5" rx="1" />
    <line x1="6" y1="18.5" x2="18" y2="18.5" />
  </BaseIcon>
);
